import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { translator } from "../../utils/i18n";
import { Trans } from "@lingui/macro";
import useForm from "react-hook-form";
import {
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useDispatch } from "react-redux";
import { addNewPerson } from "../../utils/fetcher";
import FormLabel from "@material-ui/core/FormLabel";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
  bgWhite: {
    background: "#fff"
  },
  alignCenter: {
    textAlign: "center"
  },
  dialog: {
    maxWidth: "680px",
    width: "680px"
  },
  select: {
    height: "45px"
  }
}));

export default function AddNewPerson() {
  const [open, setOpen] = React.useState(false);
  const { handleSubmit, register, errors, setValue } = useForm();
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState();
  const [parsedDate, setParsedDate] = useState();

  const today = new Date();
  const initialFocusedDate = new Date();
  const dispatch = useDispatch();
  const addNewPersonFunc = data => dispatch(addNewPerson(data, true));
  initialFocusedDate.setFullYear(today.getFullYear() - 18);
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 150);

  useEffect(() => {
    const initDate = new Date();
    setSelectedDate(initDate);
    register({
      name: "civilite",
      required: true
    });
    setValue("civilite", "1");
    const formatedDate = initDate
      ? initDate.getDate() +
        "/" +
        (initDate.getMonth() + 1) +
        "/" +
        initDate.getFullYear()
      : "";
    setValue("datenaissance", formatedDate);
    setParsedDate(formatedDate);
  }, [register]);

  const handleChangeDob = date => {
    const formatedDate = date
      ? date.day + "/" + date.month + "/" + date.year
      : "";
    setValue("datenaissance", formatedDate);
    setSelectedDate(date);
    setParsedDate(formatedDate);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeRadio = e => {
    setValue(e.target.name, e.target.value);
  };

  const onSubmit = values => {
    addNewPersonFunc(values);
    handleClose();
  };

  return (
    <div>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleClickOpen}
        startIcon={<PersonAddIcon />}
      >
        {translator()._("W_STEP_BAS_AJOUTER_UNE_PERSONNE")}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{
          paper: classes.dialog
        }}
      >
        <DialogTitle className="head-dialog-cp" id="alert-dialog-title">
          <IconButton
            className="close-dialog"
            aria-label="close"
            onClick={handleClose}
            style={{ color: "white", marginRight: "7px", padding: "0" }}
          >
            <CloseIcon />
          </IconButton>
          <div className="title-dialog-cp">
            <i className="material-icons">person_add</i>
            <span className="title-text">
              <Trans id="W_STEP_BAS_AJOUTER_UNE_PERSONNE" />
            </span>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="body-dialog">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div>
                <FormControl className="inline-radio">
                  <FormLabel className="mr-20">
                    {translator()._("W_STEP4_AJOUTER_UNE_PERSONE_CIVILITE")}
                  </FormLabel>
                  <RadioGroup
                    name="civilite"
                    onChange={onChangeRadio}
                    row
                    ref={register}
                    defaultValue="1"
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label={translator()._("W_STEP4_CIVILITE_M")}
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label={translator()._("W_STEP4_CIVILITE_MME")}
                    />
                  </RadioGroup>
                </FormControl>
                <div className="error">
                  {errors.civilite && errors.civilite.message}
                </div>
              </div>
              <div className="item-form">
                <div className="item">
                  <TextField
                    label={translator()._("W_STEP4_FORMULAIRE_NOM")}
                    variant="outlined"
                    inputRef={register({
                      required: `${translator()._(
                        "W_CE_CHAMP_EST_OBLIGATOIRE"
                      )}`
                    })}
                    name="nom"
                  />
                  <div className="error">
                    {errors.nom && errors.nom.message}
                  </div>
                </div>
                <div className="item">
                  <TextField
                    label={translator()._("W_STEP4_FORMULAIRE_PRENOM")}
                    variant="outlined"
                    inputRef={register({
                      required: `${translator()._(
                        "W_CE_CHAMP_EST_OBLIGATOIRE"
                      )}`
                    })}
                    name="prenom"
                  />
                  <div className="error">
                    {errors.prenom && errors.prenom.message}
                  </div>
                </div>
              </div>

              <div className="item-form">
                <FormControl variant="outlined" className="item">
                  <InputLabel
                    className={classes.bgWhite}
                    htmlFor="outlined-age-native-simple"
                  >
                    {translator()._("W_STEP_POPUP_FORMULAIRE_LIEN_DE_PARENTE")}
                  </InputLabel>
                  <Select
                    className={classes.select}
                    inputRef={register}
                    native
                    label={translator()._(
                      "W_STEP_POPUP_FORMULAIRE_LIEN_DE_PARENTE"
                    )}
                    inputProps={{
                      name: "parent",
                      id: "outlined-age-native-simple"
                    }}
                  >
                    <option value="autre">
                      {translator()._("W_RELATION_AUTRE")}
                    </option>
                    <option value="pere">
                      {translator()._("W_RELATION_PERE")}
                    </option>
                    <option value="mere">
                      {translator()._("W_RELATION_MERE")}
                    </option>
                    <option value="conjoint">
                      {translator()._("W_RELATION_CONJOINT")}
                    </option>
                    <option value="concubin">
                      {translator()._("W_RELATION_CONCUBIN")}
                    </option>
                    <option value="enfant">
                      {translator()._("W_RELATION_ENFANT")}
                    </option>
                  </Select>
                </FormControl>
                <div className="item">
                  <KeyboardDatePicker
                    className="field-custom-date"
                    value={selectedDate}
                    placeholder="jj/mm/aaaa"
                    onChange={handleChangeDob}
                    minDate={minDate}
                    maxDate={today}
                    format="dd/MM/yyyy"
                    label={translator()._("FORMULAIRE_DATE_DE_NAISSANCE")}
                    inputVariant="outlined"
                    name="datenaissance"
                    disableFuture
                    openTo="year"
                    views={["year", "month", "date"]}
                    okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
                    cancelLabel={<Trans id="W_ANNULER" />}
                    initialFocusedDate={initialFocusedDate}
                    invalidDateMessage={translator()._("W_DATE_INVALID")}
                    maxDateMessage={translator()._("W_MAX_DATE_MESSAGE")}
                    minDateMessage={translator()._("W_MIN_DATE_ALERT")}
                  />
                  <input
                    defaultValue={parsedDate}
                    ref={register}
                    name="datenaissance"
                    style={{ display: "none" }}
                  />
                </div>
              </div>
              <div className={classes.alignCenter}>
                <Button type="submit" color="secondary" variant="contained">
                  <Trans id="W_STEP_POPUP_AJOUTER_UN_PARTICIPANT" />
                </Button>
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
